import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { State } from '../state.types';
import { AsyncStorage } from '../../storage';
import { persistReducer } from '../persist/persist';

import { extractMarketingMeta } from './marketingMeta.utils';
import { Platform } from 'react-native';
import { MarketingMeta, MarketingMetaState } from './marketingMeta.types';

export const updateMarketingMeta = createAsyncThunk(
  'marketingMeta/update',
  () => {
    const marketingMeta = extractMarketingMeta();

    return marketingMeta;
  },
  {
    condition: (_, { getState }) => {
      if (Platform.OS !== 'web') {
        return false;
      }

      const state = getState() as State;
      const marketingMetaDataState = selectMarketingMetaDataState(state);

      return (
        marketingMetaDataState === 'idle' ||
        marketingMetaDataState === 'rejected'
      );
    },
  },
);

const initialState: MarketingMetaState = {
  dataState: 'idle',
  history: [],
  data: {},
};

const marketingMeta = createSlice({
  name: 'marketingMeta',
  initialState,
  reducers: {
    pushMarketingMetaHistoryItem(state, action: PayloadAction<MarketingMeta>) {
      state.history.push(action.payload);
    },
    updateReferrerId(
      state,
      action: PayloadAction<MarketingMeta['referrer_player_id']>,
    ) {
      state.data.referrer_player_id = action.payload;
    },
    resetMarketingMeta() {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(updateMarketingMeta.pending, (state) => {
      state.dataState = 'pending';
    });
    builder.addCase(updateMarketingMeta.fulfilled, (state, action) => {
      if (Object.keys(action.payload).length > 0) {
        state.data = action.payload;
      }

      state.dataState = 'fulfilled';
    });
    builder.addCase(updateMarketingMeta.rejected, (state) => {
      state.dataState = 'rejected';
    });
  },
});

export const {
  pushMarketingMetaHistoryItem,
  resetMarketingMeta,
  updateReferrerId,
} = marketingMeta.actions;

export const selectMarketingMeta = (state: State) =>
  state.marketingMeta.data || {};
export const selectMarketingMetaHistory = (state: State) =>
  state.marketingMeta.history;
export const selectMarketingMetaDataState = (state: State) =>
  state.marketingMeta.dataState;

const persistConfig = {
  key: 'marketingMeta',
  storage: AsyncStorage,
  whitelist: ['data', 'history'],
};

const persistedReducer = persistReducer(persistConfig, marketingMeta.reducer);

export default persistedReducer;
